import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useDiary } from "@/context/DiaryContext";
import { useAuth } from "@/context/AuthContext";
import { diaryService } from "@/services/diaryService";
import styles from "./styles";

export default function DailyReason() {
  const navigate = useNavigate();
  const { diaryData, updateDiaryData, setIsLoadingAIResponse } = useDiary();
  const [reasonText, setReasonText] = useState<string>(
    diaryData.description || ""
  );
  const { token } = useAuth();

  useEffect(() => {
    if (diaryData.description && !reasonText) {
      setReasonText(diaryData.description);
    }
  }, [diaryData.description]);

  const handleBack = () => {
    navigate("/records/daily-emotion");
  };

  const handleNext = async () => {
    try {
      updateDiaryData({ description: reasonText });
      setIsLoadingAIResponse(true);
      navigate("/records/daily-tips");

      const response = await diaryService.createEntry(token!, {
        feeling: diaryData.feeling! as
          | "TERRIBLE"
          | "BAD"
          | "NEUTRAL"
          | "GOOD"
          | "GREAT",
        description: reasonText,
        audioUrl: diaryData.audioUrl || "",
      });

      updateDiaryData({ aiResponse: response.aiResponse });
      setIsLoadingAIResponse(false);
    } catch (error) {
      console.error("Error al registrar el diario:", error);
      setIsLoadingAIResponse(false);
    }
  };

  return (
    <div style={styles.contentContainer}>
      <div style={{ ...styles.scrollContainer, overflowY: "auto", flex: 1 }}>
        <h1 style={styles.title}>¿Qué pasó?</h1>

        <textarea
          style={styles.textInput}
          placeholder="Escribe algo aquí..."
          onChange={(e) => setReasonText(e.target.value)}
          value={reasonText}
          rows={6}
        />
      </div>

      <div style={styles.buttonsContainer}>
        <button style={styles.backButton} onClick={handleBack}>
          <span style={styles.backButtonText}>Atrás</span>
        </button>
        <button style={styles.nextButton} onClick={handleNext}>
          <span style={styles.nextButtonText}>Siguiente</span>
        </button>
      </div>
    </div>
  );
}
